import TableList from "components/Common/TableList"
import React from "react"
import { useMemo } from "react"

function ProductValidationTable({ category }) {
  const columns = useMemo(
    () => [
      {
        Header: "SrNo",
        accessor: "SrNo",
        Cell: ({ row }) => {
          return (
            <div
              style={{ color: row.original.ErrorMessage != "N/A" ? "red" : "" }}
            >
              {row.original.SrNo}
            </div>
          )
        },
      },
      {
        Header: "Name",
        accessor: "Name",
        Cell: ({ row }) => {
          return (
            <div
              style={{ color: row.original.ErrorMessage != "N/A" ? "red" : "" }}
            >
              {row.original.Name}
            </div>
          )
        },
      },
      {
        Header: "Rent",
        accessor: "Rent",
        Cell: ({ row }) => {
          return (
            <div
              style={{ color: row.original.ErrorMessage != "N/A" ? "red" : "" }}
            >
              {row.original.Rent}
            </div>
          )
        },
      },
      {
        Header: "Category",
        accessor: "CategoryName",
        Cell: ({ row }) => {
          return (
            <div
              style={{ color: row.original.ErrorMessage != "N/A" ? "red" : "" }}
            >
              {row.original.CategoryName}
            </div>
          )
        },
      },
      {
        Header: "Size",
        accessor: "SizeName",
        Cell: ({ row }) => {
          return (
            <div
              style={{ color: row.original.ErrorMessage != "N/A" ? "red" : "" }}
            >
              {row.original.SizeName}
            </div>
          )
        },
      },
      {
        Header: "Color",
        accessor: "ColorName",
        Cell: ({ row }) => {
          return (
            <div
              style={{ color: row.original.ErrorMessage != "N/A" ? "red" : "" }}
            >
              {row.original.ColorName}
            </div>
          )
        },
      },
      {
        Header: "Code",
        accessor: "Code",
        Cell: ({ row }) => {
          return (
            <div
              style={{ color: row.original.ErrorMessage != "N/A" ? "red" : "" }}
            >
              {row.original.Code}
            </div>
          )
        },
      },
      {
        Header: "Remarks",
        accessor: "Remarks",
        Cell: ({ row }) => {
          return (
            <div
              style={{ color: row.original.ErrorMessage != "N/A" ? "red" : "" }}
            >
              {row.original.Remarks}
            </div>
          )
        },
      },
      {
        Header: "Error Message",
        accessor: "ErrorMessage",
        Cell: ({ row }) => {
          return (
            <div
              style={{ color: row.original.ErrorMessage != "N/A" ? "red" : "" }}
            >
              {row.original.ErrorMessage}
            </div>
          )
        },
      },
    ],
    []
  )

  return (
    <div>
      <TableList
        columns={columns}
        data={category}
        isGlobalFilter={true}
        isCategoryList={true}
        customPageSize={category.length}
        className="custom-header-css"
      />
    </div>
  )
}

export default ProductValidationTable
